// Apps
export const APP_PPC = 'ppc';
export const APP_ECC = 'ecc';
export const APP_AC = 'ac';

export const PPC_STARGATE_PREFIX = '/gateway/api/css-xp-ppc';
export const ECC_STARGATE_PREFIX = '/gateway/api/css-xp-ecc';
